import React, {useState, useEffect} from 'react';
import { useForm, Controller} from 'react-hook-form';
import ReactDOM from 'react-dom';
import administerService from '../../services/AdministratorService';
import "./Layer.css";
import "../../static/css/alert.css";

export default function LayerConfirmAdmin({show,onClose,item}) {
    const defaultValues = {
        emailConfirm: item.email,
    };
    const { register, control, handleSubmit, reset,formState: { errors } } = useForm({
        defaultValues
    });
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        onClose();
    };

    const handleActionEvent= async (data) => {
        const payload = {
            ...data,
            administrator:{id_admin: item.id_admin}
        };
        administerService.confirm(payload)
            .then((res) => {
                setMessage("Email di conferma inviata con successo!");
                setErrorMsg("");
            }).catch((error) => {
                console.error("Error confirm administrator: ", error);
                setMessage("");
                setErrorMsg("Errore invio email di conferma, riprova.");
            }
        );
    }

    useEffect(() => {
        reset(item);
    }, [item, reset]);

    return ReactDOM.createPortal(
        <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h3 className="offcanvas-title">Conferma Amministratore</h3>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <div className="col-md-12">
                    <div className="list-single-main-item-title fl-wrap">
                        <h4>Qui puoi confermare, correggere o completare i dati del tuo profilo professionale senza registrarti:<span> ti basta confermare via e-mail</span></h4>
                    </div>
                </div>
                <form className="custom-form pt-0" onSubmit={handleSubmit(handleActionEvent)}>
                    <input {...register("type", { value: "CONFERMA DATI" })} type="hidden" />
                    <fieldset>
                        <div className="col-md-6">
                            <label><i className="fa fa-user-o"></i></label>
                            <input className={`${errors.name ? "error" : ""}`}
                                type="text"
                                placeholder={`${errors.name ? errors.name.message : "Nome *"}`}
                                {...register("name", {
                                    required: "Nome richiesto!"
                                })}
                            />
                            {errors.name && <div className="invalid-input">{errors.name.message}</div>}
                        </div>
                        <div className="col-md-6">
                            <label><i className="fa fa-envelope-o"></i> </label>
                            <input className={`${errors.email ? "error" : ""}`}
                                type="text"
                                placeholder={`${errors.email ? errors.email.message : "Email *"}`}
                                {...register("emailConfirm", {
                                    required: "Email richiesta!",
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: "Email non valida!"
                                    }
                                })}
                            />
                            {errors.email && <div className="invalid-input">{errors.email.message}</div>}
                        </div>
                        <div className="col-md-6">
                            <label><i className="fa fa-address-card-o"></i></label>
                            <input className={`${errors.piva ? "error" : ""}`}
                                type="text"
                                placeholder={`${errors.piva ? errors.piva.message : "PIVA/CF"}`}
                                {...register("piva")}
                            />
                        </div>
                        <div className="col-md-6">
                            <label><i className="fa fa-phone"></i></label>
                            <input className={`${errors.phone ? "error" : ""}`}
                                type="text"
                                placeholder={`${errors.phone ? errors.phone.message : "Telefono"}`}
                                {...register("phone")}
                             />
                        </div>
                        <div className="col-md-12">
                            <label><i className="fa fa-map-marker"></i>  </label>
                            <input className={`${errors.address ? "error" : ""}`}
                                type="text"
                                placeholder={`${errors.address ? errors.address.message : "Indirizzo"}`}
                                {...register("address")}
                             />
                        </div>
                        <div className="col-md-6">
                            <label><i className="fa fa-globe"></i>  </label>
                            <input className={`${errors.comune ? "error" : ""}`}
                                type="text"
                                placeholder={`${errors.comune ? errors.comune.message : "Comune"}`}
                                {...register("comune")}
                             />
                        </div>
                        <div className="col-md-3">
                            <label><i className="fa fa-globe"></i>  </label>
                            <input className={`${errors.provincia ? "error" : ""}`}
                                type="text"
                                placeholder={`${errors.provincia ? errors.provincia.message : "Provincia"}`}
                                {...register("provincia", {
                                    pattern: {
                                        value: /^[a-zA-Z]+$/,
                                        message: "Provincia non valida!"
                                    },
                                    maxLength: {
                                        value: 2,
                                        message: "Inserire la sigla!",
                                    },
                                    minLength: {
                                        value: 2,
                                        message: "Inserire la sigla!",
                                    }
                                })}
                            />
                            {errors.provincia && <div className="invalid-input">{errors.provincia.message}</div>}
                        </div>
                        <div className="col-md-3">
                            <label><i className="fa fa-thumb-tack "></i>  </label>
                            <input className={`${errors.cap ? "error" : ""}`}
                                type="text"
                                placeholder={`${errors.cap ? errors.cap.message : "Cap"}`}
                                {...register("cap")}
                             />
                        </div>
                        <div className="col-md-12">
                            <label><i className="fa fa-info "></i>  </label>
                            <textarea placeholder="Descrizione..."
                                {...register("description")}
                             />
                            <div className="filter-tags">
                                <input id="privacy" type="checkbox" name="privacy" required />
                                <label htmlFor="privacy">Inviando la richiesta accetti la memorizzazione e la gestione dei tuoi dati da questo sito web. Ai sensi dell’art. 13 del D. Lgs. 196/2003 e dell’art. 13 del Regolamento (UE) 2016/679.</label>
                            </div>
                        </div>
                        <div className="clearfix"/>
                    </fieldset>
                    <button className="btn  big-btn  color-bg flat-btn">Invia<i className="fa fa-angle-right"></i></button>
                </form>
            </div>
        </div>,
        document.body
    );

}